import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=76fe1055&scoped=true&"
import script from "./LanguageToggle.vue?vue&type=script&lang=js&"
export * from "./LanguageToggle.vue?vue&type=script&lang=js&"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=76fe1055&prod&lang=scss&scoped=true&"
import style1 from "./LanguageToggle.vue?vue&type=style&index=1&id=76fe1055&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fe1055",
  null
  
)

export default component.exports